import { render, staticRenderFns } from "./AppealsList.vue?vue&type=template&id=708f1393&"
import script from "./AppealsList.vue?vue&type=script&lang=js&"
export * from "./AppealsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports